<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
       <!-- Content Header (Page header) -->
        <section class="content-header">
         
        </section>
  
            <!-- Main content -->
            <section class="content">
                <div class="box">
                
                    <div class="box-body" style="min-height:400px;">
                        <h3><strong>Update Profile</strong></h3>
                        <hr>
                        <div class="account-box">
                        <form role="form">

                        <div class="form-group"> 
                        
                                <label for="inputName">First Name: </label>
                                <input id="inputName" v-model="firstName"   class="form-control">
                                </div>
                        
                    <hr>
                        <div class="form-group"> 
                        
                                <label for="inputPassword">Last Name: </label>
                                <input id="inputPassword" v-model="lastName"  class="form-control" >
                        
                    </div>
                                        <hr>
                                <el-tooltip content="Email must be changed through the login service." placement="right">

                        <div class="form-group"> 
                                <label for="inputPassword">Email: </label>
                                
                                <input id="inputPassword" v-model="email" :disabled="true"  class="form-control">
                               
                    </div>
                     </el-tooltip>
                                        <hr>
 <div class="form-group"> 
                        
                                <label for="inputPassword">Phone: </label>
                                <input id="inputPassword" v-model="phone" class="form-control">
                        
                    </div>
                                        <hr>
                        <div class="form-group"> 
                        
                                <label for="inputPassword">City: </label>
                                <input id="inputPassword" v-model="city"  class="form-control">
                        
                    </div>
                                        <hr>

                        <div class="form-group"> 
                        
                                <label for="inputPassword">State: </label>
                                <input id="inputPassword" v-model="state"   class="form-control">
                        
                    </div>
                                        <hr>

                    <div class="form-group"> 
                        
                                <label for="inputPassword">Zipcode: </label>
                                <input id="inputPassword" v-model="zipcode"  class="form-control">
                        
                    </div>
                        </form>
                        </div>
                                        <hr>

            
                    <br>
                    <br>
                    <hr>
                                <div class="col-md-12 row-block"> <a  class="btn btn-primary btn-block" href='#' v-on:click="saveChanges">Save Changes</a> </div>

                    <hr>
                    </div>
                </div>
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
import Buttons from './modules/ui/Buttons.vue'
const cliStorage = require('../services/libraries/clientStoragelib')
const cliStorNames = cliStorage.clientStorageNames
        var to = require('await-to-js').default
          const commonDB = require('../services/database/common')

const db = require('../services/database/database')
const Auth = require('../services/Authentication/auth')
const cliStoreOps = require('../common/clientStorageOperations')
const models = require('../services/database/models')

  export default {
  components: { Buttons },
    name: 'updateProfile',
    props:['user'], 
    watch: {
  input: function () {
    if (isLocalStorage() /* function to detect if localstorage is supported*/) {
      localStorage.setItem('storedData', this.input)
    }
  }
},
    async beforeMount(){
      //possibly think opf a more secure way to store these vars 
      if (window.localStorage) {
    this.firstName = localStorage.getItem(cliStorNames.FIRST_NAME.name)
     this.lastName = localStorage.getItem(cliStorNames.LAST_NAME.name)
      this.city = localStorage.getItem(cliStorNames.CITY.name)
       this.email = localStorage.getItem(cliStorNames.EMAIL.name)
     this.phone = localStorage.getItem(cliStorNames.PHONE.name)
      this.state = localStorage.getItem(cliStorNames.STATE.name)
       this.zipcode = localStorage.getItem(cliStorNames.ZIPCODE.name)
       
      }
      this.userId = this.$cookie.get(cliStorNames.USER_ID.name)
        this.userToken = this.$cookie.get(cliStorNames.USER_TOKEN.name)
        if (!this.userToken){
         
            cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()
                  this.$router.push('/login')
        }
      const jwt_decode = require('jwt-decode');
      const decoded_header = jwt_decode(this.userToken)
      this.userAccountId = decoded_header.user_id
      if (!this.userId){
         this.userId = this.$route.params.userId
      }
       let userErr, userRes
          [userErr, userRes] = await to(Auth.getUser({ UID: this.userToken }));
          if (userErr) {
            console.log("getting user userErr", userErr.response);
            cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()
                  this.$router.push('/login')

          } 

          let userDbRes, userDbErr; 
                  [userDbErr, userDbRes]= await to(commonDB.getUserFromDB(this.userToken, this.userAccountId))
                  if (userDbErr){
                      console.error(userDbErr)
                      this.$confirm("Unable to Load Profile Contents. Please try again at a later time.", 'User Profile Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
                  }
                  console.log(userDbRes)
                  try{
                                    let pulledUserId = userDbRes.data.fields.userId.stringValue
                                    //VERY IMPORTANT! ==> Keeps 1 user from accesing another user's profile
                if (pulledUserId !== this.userId){
                     this.$confirm("Unable to retrieve User Profile. Please try again at a later time.", 'User Profile Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
}
                   this.firstName = userDbRes.data.fields.firstName.stringValue
                this.lastName = userDbRes.data.fields.lastName.stringValue
                this.email = userDbRes.data.fields.email.stringValue
                this.phone = userDbRes.data.fields.phone.stringValue
                this.zipcode = userDbRes.data.fields.zipcode.stringValue
                this.city = userDbRes.data.fields.city.stringValue
                this.state = userDbRes.data.fields.state.stringValue
                this.userCreationDate = userDbRes.data.fields.userCreationDate.stringValue

}

       catch(err){
                    console.error(err)
                     this.$confirm("Unable to retrieve User Profile. Please try again at a later time.", 'User Profile Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
           }
    },
//need to clear fro local str maybe
    created(){
    
      
//       if (window.localStorage) {
                               

//                 if (!localStorage.getItem(cliStorNames.FIRST_NAME.name)){
//                 localStorage.setItem(cliStorNames.FIRST_NAME.name, this.$route.params.user.firstName)

//                 }
// {
//                                 if (!localStorage.getItem(cliStorNames.LAST_NAME.name))
//                 localStorage.setItem(cliStorNames.LAST_NAME.name, this.$route.params.user.lastName)

// }
//                 if (!localStorage.getItem(cliStorNames.EMAIL.name)){
//                 localStorage.setItem(cliStorNames.EMAIL.name, this.$route.params.user.email)

//                 }
//                                 if (!localStorage.getItem(cliStorNames.PHONE.name)){
//                 localStorage.setItem(cliStorNames.PHONE.name, this.$route.params.user.phone)

//                                 }
//                                 if (!localStorage.getItem(cliStorNames.CITY.name)){
//                                                     localStorage.setItem(cliStorNames.CITY.name, this.$route.params.user.city)

//                                 }
//                                 if (!localStorage.getItem(cliStorNames.STATE.name)){
//                                                     localStorage.setItem(cliStorNames.STATE.name, this.$route.params.user.state)

//                                 }
//                                 if (!localStorage.getItem(cliStorNames.ZIPCODE.name)){
                                    
                            
//                 localStorage.setItem(cliStorNames.ZIPCODE.name, this.$route.params.user.zipcode)}
//       }


    },
    beforeDestroy(){
    //   if (window.localStorage) {
    //     localStorage.removeItem(cliStorNames.FIRST_NAME.name)
    //   localStorage.removeItem(cliStorNames.LAST_NAME.name)
    //   localStorage.removeItem(cliStorNames.CITY.name)
    //    localStorage.removeItem(cliStorNames.EMAIL.name)
    //  localStorage.removeItem(cliStorNames.PHONE.name)
    //   localStorage.removeItem(cliStorNames.STATE.name)
    //     localStorage.removeItem(cliStorNames.ZIPCODE.name)
    //  localStorage.removeItem(cliStorNames.USER_ID.name)
    //   }
},
    
    data (){
        return {
            // variables changed here will be updated in the DB
            firstName: "",
            lastName: "",
            userAccountId: "",
            email: "",
            phone: "",
            zipcode: "",
            city: "",
            state: "",
             username: "",
             userId: "",
            firstNameEditFlag: true,
             lastNameEditFlag: false,
              emailEditFlag: false,
               phoneEditFlag: false,
                cityEditFlag: false,
                stateEditFlag: false,
                zipEditFlag: false,
                firstNameEditValue: "",
             lastNameEditValue: "",
              emailEditValue: "",
               phoneEditValue: "",
                cityEditValue: "",
                stateEditValue: "",
                zipEditValue: "",
                display: true
        }
    },
    methods:{
    changeFirstNameFlag:function(){
        console.log(this.firstNameEditFlag)
        this.firstNameEditFlag = !(this.firstNameEditFlag);
   this.display = false

  // If you like promises better you can
  // also use nextTick this way
//   this.$nextTick().then(() => {
//     // Add the component back in
// this.display = true
//   });
  this.display = true
        
        
       // this.firstNameEditFlag = !(this.firstNameEditFlag);
         console.log(this.firstNameEditFlag)


    },
    changeLastNameFlag:function(){
        console.log(flag)
        flag = !(flag);
         console.log(flag)


    },
    updateClientStorage: function(firstName, lastName, city, email, phone, state, zipcode){
        this.firstName = localStorage.setItem(cliStorNames.FIRST_NAME.name, firstName)
     this.lastName = localStorage.setItem(cliStorNames.LAST_NAME.name, lastName)
      this.city = localStorage.setItem(cliStorNames.CITY.name, city)
       this.email = localStorage.setItem(cliStorNames.EMAIL.name, email)
     this.phone = localStorage.setItem(cliStorNames.PHONE.name, phone)
      this.state = localStorage.setItem(cliStorNames.STATE.name, state)
       this.zipcode = localStorage.setItem(cliStorNames.ZIPCODE.name, zipcode)
    },
      saveChanges: function(){
     setTimeout(this._saveChanges, 500)
   },
    _saveChanges:async function(){


                   this.$confirm("Do you want to save these changes?", 'Update Profile', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'info'}).then(res => {
          console.log("DONE!!!!")
          this.updateDB()}).then(res => {console.log("uploaded")
        this.updateClientStorage(this.firstName, this.lastName, this.city,  this.email,this.phone ,this.state, this.zipcode  )
        this.$router.push("/userProfile/" + this.userId)
        }
          ).catch(err => {
            console.error(err)
            return
        })

    
    },
    updateDB: async function(){
        
let dbErr, dbRes;
      [dbErr, dbRes] = await to(commonDB.updateUser(this.userToken, this.userAccountId, this.firstName, this.lastName, this.phone, this.email, this.zipcode, this.city, this.state))
       if (dbErr){
        console.error("ERROR", dbErr)
        throw err
    }
    else if(dbRes){
        console.log("User added to DB!", dbRes)
    }
            

    },
    changeEmailFlag:function(){
        console.log(flag)
        flag = !(flag);
         console.log(flag)


    },
    changePhoneFlag:function(){
        console.log(flag)
        flag = !(flag);
         console.log(flag)


    },
    changeCityFlag:function(){
        console.log(flag)
        flag = !(flag);
         console.log(flag)


    },
    changeStateFlag:function(){
        console.log(flag)
        flag = !(flag);
         console.log(flag)


    },
      changeZipFlag:function(){
        console.log(flag)
        flag = !(flag);
         console.log(flag)


    }
    }
  }
</script>



// WEBPACK FOOTER //
// updateProfile.vue?0bb6e422